// Hulk Wishlist Enhancer - Full Inline Version with Stock Fallback
(function () {
  if (!window) return;

  const productCache = {};

  // Fetch product JSON once per handle
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    const p = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);

    productCache[handle] = p;
    return p;
  }

  // Enhance a single wishlist card
  function enhanceCard(card) {
    if (!card || card.classList.contains("hulk-enhanced")) return;

    const handle = card.getAttribute("data-handle");
    const variantId = card.getAttribute("data-varid");
    if (!handle) return;

    const meta = window.productMetafields?.[handle];
    const content = card.querySelector(".wishlist__product-content");
    if (!content) return;

    fetchProduct(handle).then(product => {
      if (!product) return;

        format = window.theme.settings.money_with_currency_format || "${{amount}}";
        var amount_text = formatMoney(product.price, format);

        const priceEl = content.querySelector(".hulk-price span");
        if (priceEl) priceEl.textContent = amount_text;
    });

    card.classList.add("hulk-enhanced");
  }

  // Enhance all wishlist cards
  function enhanceAll() {
    document.querySelectorAll(".wishlist-card").forEach(enhanceCard);
  }

  // Observe dynamic wishlist additions via AJAX
  function observeWishlist() {
    const container = document.querySelector(".wishlist-grid-view") || document.body;

    const observer = new MutationObserver(() => {
      enhanceAll();
    });

    observer.observe(container, { childList: true, subtree: true });

    // Initial run
    enhanceAll();
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWishlist);
  } else {
    observeWishlist();
  }
})();
